// Common color keywords to search for in descriptions
const colorKeywords = [
    'black', 'white', 'gray', 'grey', 'silver', 'blue', 'red', 'green',
    'brown', 'beige', 'tan', 'gold', 'yellow', 'orange', 'purple',
    'burgundy', 'charcoal', 'turquoise', 'pink',
];

// Special cases where keyword differs from output
const colorMap = {
    grey: 'gray', // normalize grey to gray
};

/**
 * Helper function to extract color variant from color value or description
 * @param {string} colorValue - The direct color value (e.g., 'GRAY')
 * @param {string} description - The color description (e.g., 'Black Noir Pearl Mica Exterior')
 * @returns {string|null} - The lowercase color variant for ColorSwatch or null
 */
export const getColorVariant = (colorValue, description) => {
    // If we have a direct color value, use it
    if (colorValue) {
        return colorValue.trim().toLowerCase();
    }

    // If no direct color value, try to extract from description
    if (description) {
        const formattedDescription = description.trim().toLowerCase();

        // Look for color keywords in the description
        const foundKeyword = colorKeywords.find((keyword) => formattedDescription.includes(keyword));

        if (foundKeyword) {
            return colorMap[foundKeyword] || foundKeyword;
        }
    }

    return null;
};

/**
 * Extracts and processes color data for both exterior and interior colors from vehicle specs
 * @param {Array} SpecsData - Array of vehicle specification objects
 * @returns {Object} Object containing exteriorColorData and interiorColorData
 */
export const getColorSwatchData = (SpecsData) => {
    // Find exterior and interior color specs to extract colorValue
    const exteriorColor = SpecsData?.find((spec) => spec.key === 'exterior');
    const interiorColor = SpecsData?.find((spec) => spec.key === 'interiorSeats');

    const { colorValue: interiorColorValue, value: interiorColorDescriptionValue } = interiorColor?.specData || {};
    const { colorValue: exteriorColorValue, value: exteriorColorDescriptionValue } = exteriorColor?.specData || {};

    // Get color variants using helper function
    const exteriorColorData = {
        colorVariant: getColorVariant(exteriorColorValue, exteriorColorDescriptionValue),
        colorValue: exteriorColorValue,
        colorDescription: exteriorColorDescriptionValue,
    };

    const interiorColorData = {
        colorVariant: getColorVariant(interiorColorValue, interiorColorDescriptionValue),
        colorValue: interiorColorValue,
        colorDescription: interiorColorDescriptionValue,
    };

    return {
        exteriorColorData,
        interiorColorData,
    };
};
